import infoBarMessageCreatorsMap from '../utils/infoBarMessageCreatorsMap';
import { action } from 'satcheljs/lib/legacy';
var addInfoBarMessageInReadingPane = action('addInfoBarMessageInReadingPane')(function addInfoBarMessageInReadingPane(viewState, messageId, infoBarMessageViewStateCreator) {
    if (viewState.infoBarIds.indexOf(messageId) == -1) {
        viewState.infoBarIds.push(messageId);
    }
    else {
        // clone infoBarIds to force re-render
        viewState.infoBarIds = viewState.infoBarIds.slice();
    }
    if (infoBarMessageViewStateCreator) {
        if (!infoBarMessageCreatorsMap[viewState.itemId]) {
            infoBarMessageCreatorsMap[viewState.itemId] = {};
        }
        infoBarMessageCreatorsMap[viewState.itemId][messageId] = infoBarMessageViewStateCreator;
    }
});
export default addInfoBarMessageInReadingPane;
//# sourceMappingURL=addInfoBarMessageInReadingPane.js.map